(function ($, Drupal, once) {
  Drupal.behaviors.mygsap = {
    attach: function (context) {
      // Nur einmal pro Seite initialisieren
      once('gsap-header-trigger', 'body', context).forEach(function () {
        if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

        gsap.registerPlugin(ScrollTrigger);

        gsap.to('header', {
          scrollTrigger: {
            trigger: '#block-woar-theme-hauptnavigation',
            start: 'top top',
            end: 'max',
            pin: true,
            pinSpacing: false,
            toggleClass: { targets: 'header', className: 'docked' },
            // markers: true,
            toggleActions: 'play none none none',
          }
        });
      });
    }
  };
})(jQuery, Drupal, once);
